import React from "react";
import { useLanguage } from "../contexts/LanguageContext";

export default function LanguageSwitcher() {
  const { language, setLanguage, languageLabels, pick } = useLanguage();
  const label = pick({
    en: "Language",
    pl: "Jezyk",
    es: "Idioma",
  });

  return (
    <label
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 10,
        padding: "10px 14px",
        borderRadius: 14,
        border: "1px solid rgba(255, 213, 116, 0.38)",
        background: "rgba(255, 213, 116, 0.08)",
        color: "#fff1c8",
        fontWeight: 800,
      }}
    >
      <span>{label}</span>
      <select
        value={language}
        onChange={(event) => setLanguage(event.target.value)}
        style={{
          borderRadius: 10,
          border: "1px solid rgba(255,255,255,0.22)",
          background: "rgba(11, 18, 34, 0.95)",
          color: "#fff1c8",
          padding: "8px 10px",
          fontWeight: 700,
        }}
      >
        {Object.entries(languageLabels).map(([value, label]) => (
          <option key={value} value={value}>
            {label}
          </option>
        ))}
      </select>
    </label>
  );
}
